<template>

<v-dialog v-model="dialog" width="700px">
  <v-card>
    <v-card-title>Creating XML file for ABN-AMRO telebanking</v-card-title>
    <v-container fluid>
    <v-row>
      <v-col>
        Please wait ....
      </v-col>
    </v-row>  
    <v-row>
      <v-col>
        Total amount : {{hspt.totaalBedrag}}
      </v-col>
    </v-row> 
    <v-row>
      <v-col>
        {{hspt.hash}}
      </v-col>
    </v-row>  

    </v-container>
  
     <v-card-actions>  
       <v-spacer></v-spacer>
           <!-- <v-btn class="primary mx-2" small @click="saveHsfp">Save</v-btn> -->
           <v-btn color="primary"  small @click="close()">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      hspt_encrid: null,
      hash: '',
      hspt: {},
    }
  },
  methods: {
    open(hspt_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/task/fin/abn/exportBtod.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "exportBtod"
          },
          exportBtod: {
            hspt_encrid: hspt_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hspt = res.data.exportBtod;
            this.hash = this.hspt.hash;
            /* window.open(this.hspt.filename,'_blank'); */
            
             var e = document.createElement('a');
             var href = 'data:application/xml;charset=utf-8,' + encodeURIComponent(this.hspt.xml);
             e.setAttribute('href', href);
             e.setAttribute('download', this.hspt.filename);
             document.body.appendChild(e);
             e.click();
             document.body.removeChild(e);
 
            /* this.dialog = false; */
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    close() {
      this.dialog = false;
      this.$router.reload('/task/fin/abn/searchBtodNew');
    }
  }
}
</script>

